module.exports = __webpack_public_path__ + "static/media/logo113.bfb7f868.png";